
const TextField = ({ className, ...props }) => <input className={className ? `form-control ${className}` : "form-control"} {...props} />

export default TextField
